"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bids = void 0;
const client_1 = require("@arkecosystem/client");
class Bids extends client_1.Resource {
    async getAllBids(query) {
        return this.sendGet("nft/exchange/bids", query);
    }
    async getBidById(id) {
        return this.sendGet(`nft/exchange/bids/${id}`);
    }
    async getBidsWallets(id) {
        return this.sendGet(`nft/exchange/bids/${id}/wallets`);
    }
    async searchByBid(payload, query) {
        return this.sendPost("nft/exchange/bids/search", payload, query);
    }
    async getAllCanceledBids(query) {
        return this.sendGet("nft/exchange/bids/canceled", query);
    }
    async getCanceledBidById(id) {
        return this.sendGet(`nft/exchange/bids/canceled/${id}`);
    }
}
exports.Bids = Bids;
//# sourceMappingURL=bids.js.map